
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/warranty",
      function () {
        return require("private-next-pages/warranty/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/warranty"])
      });
    }
  